import { render } from "./ModalContentInfo.vue?vue&type=template&id=372a7e0a&scoped=true"
import script from "./ModalContentInfo.vue?vue&type=script&lang=js"
export * from "./ModalContentInfo.vue?vue&type=script&lang=js"

import "./ModalContentInfo.vue?vue&type=style&index=0&id=372a7e0a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372a7e0a"]])

export default __exports__